import { Box, Typography } from '@mui/material';
import { localSeoSignUpSx, signUpToolPageSxs } from '../signupSx';
import { signUpToolPageTexts } from 'src/common/config/TextMessage';
import { AvatarGroupModule } from 'src/common/AvatarGroupsModule';

export const LocalSeoToolPage = () => {
  return (
    <>
      <Box
        className="hidden relative  md:flex md:flex-col"
        sx={{
          ...localSeoSignUpSx?.mainContainer,
          background:
            'linear-gradient(129deg, #2F1A72 13.83%, var(--color-primary) 68.05%);'
        }}
      >
        <Box
          sx={{
            //flex: 'none',
            width: 'auto',
            overflow: 'hidden',
            marginLeft: 'auto',
            marginTop: '22px',
            display: 'flex',
            alignItems: 'center', // vertical center
            justifyContent: 'flex-end',
            height: '100%'
          }}
        >
          <img
            src={process.env.PUBLIC_URL + signUpToolPageTexts?.localSeoSignUpBg}
            loading="lazy"
            style={{
              width: '100%', // Full width
              objectFit: 'contain', // Maintain aspect ratio, fill container,
              height: '100%'
            }}
          />
        </Box>
        <Box className="mr-6 pb-4">
          <Typography sx={signUpToolPageSxs?.footerTextSx}>
            {signUpToolPageTexts?.footerText}
          </Typography>
          <Box sx={signUpToolPageSxs?.avatarBoxSx}>
            <AvatarGroupModule />
          </Box>
        </Box>
      </Box>
    </>
  );
};
